import Swiper, { Autoplay } from 'swiper';
import 'swiper/css';

export default class {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.swiper');

    this.slider = null;
    this.option = {
      modules: [Autoplay],
      init: false,
      loop: true,
      speed: 1200,
      slidesPerView: 'auto',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      // navigation: {
      //   nextEl: this.dom.el.querySelector('.swiper-button-next'),
      //   prevEl: this.dom.el.querySelector('.swiper-button-prev'),
      // },
      // breakpoints: {
      //   768: {
      //     centeredSlides: true,
      //     slidesPerView: 1314 / 396
      //   }
      // }
    };

    this.init();
  }

  init() {
    this.slider = new Swiper(this.dom.slider, this.option);
    this.slider.init();
  }

  destroy() {
    this.slider.destroy(true, true);
  }
}
